(() => {
  angular
    .module('gm.common.services')
    .factory('btgPayments', btgPaymentsFactory);

  function btgPaymentsFactory(
    $window,
    btgUser,
    GmyFeatures,
    gmApi,
    GmyStorage
  ) {
    'ngInject';

    const COOKIE_NAME_PAYMENT_ID = 'invoice_id_to_pay';

    const REQUEST_TYPES = {
      PAYMENT_REQUEST: 'request_payment',
      INVOICE: 'invoice'
    };

    function prepareStartDate(startDate) {
      return $window.moment(startDate).isSame($window.moment(), 'day') ? null : startDate;
    }

    const service = {
      REQUEST_TYPES,
      canRequestPayment,
      canSendGift,
      canSendPayment,
      fixPaymentGoldAmount,
      getPaymentId,
      getRequestsToPay,
      needsVerification,
      payRequest,
      rejectRequest,
      removePaymentId,
      requestPayment,
      sendPayment,
      storePaymentId,
    };

    return service;

    function canRequestPayment() {
      return GmyFeatures.checkEnabledAndCountry('sendInvoice')
      .then((enabled) => {
        if (getProfileCountryCode() === 'US' && !btgUser.getProfile().profileVerified) {
          return false;
        }
        return enabled;
      });
    }

    function canSendGift() {
      return GmyFeatures.checkEnabledAndCountry('sendGift')
      .then((enabled) => {
        if (getProfileCountryCode() === 'US' && !btgUser.getProfile().profileVerified) {
          return false;
        }
        return enabled;
      });
    }

    function canSendPayment() {
      return GmyFeatures.checkEnabledAndCountry('sendPayment')
      .then((enabled) => {
        if (getProfileCountryCode() === 'US' && !btgUser.getProfile().profileVerified) {
          return false;
        }
        return enabled;
      });
    }

    function fixPaymentGoldAmount(requestId, isAuthed = true) {
      return gmApi.patch(`users/invoices/${requestId}`, null, {
        auth: isAuthed
      });
    }

    function getPaymentId() {
      return GmyStorage.getSessionItem(COOKIE_NAME_PAYMENT_ID);
    }

    function getProfileCountryCode() {
      const profile = btgUser.getProfile();

      if (profile && profile.countryCode) {
        return profile.countryCode.toUpperCase();
      }

      return null;
    }

    function getRequestsToPay() {
      return gmApi.get('users/invoices/in/pending').then(data => data.userInvoices);
    }

    function needsVerification() {
      return getProfileCountryCode() === 'US' && !btgUser.getProfile().profileVerified;
    }

    function payRequest(requestId, vaultId, twoFactAuth) {
      const data = { vaultId };

      return gmApi.post(`users/invoices/${requestId}`, data, { twoFactAuth, auth: true });
    }

    function rejectRequest(request) {
      return gmApi.delete(`users/invoices/in/pending/${request.id}`, { auth: true });
    }

    function removePaymentId() {
      GmyStorage.removeSessionItem(COOKIE_NAME_PAYMENT_ID);
    }

    function requestPayment(to, amount, currency, message, {
      period, startDate: origStartDate
      }, captcha) {
      const recipient = {};

      if (to.email) {
        recipient.email = to.email;
      }

      if (to.phone) {
        recipient.phone = to.phone;
      }

      if (!to.id && to.fullName) {
        recipient.fullName = to.fullName;
      }

      const startDate = prepareStartDate(origStartDate);

      const payload = {
        amount,
        currency,
        period,
        startDate,
        message,
        recipient,
        subject: ''
      };

      return gmApi.post('users/invoices', payload, { auth: true, captcha });
    }

    function sendPayment(to, amount, currency, vaultId, message,
      { period, startDate: origStartDate }, twoFactAuth) {
      const startDate = prepareStartDate(origStartDate);

      const payload = {
        to: to.email || to.phone,
        amount,
        currency,
        vaultId,
        message,
        period,
        startDate
      };

      return gmApi.post('payments/send', payload, { twoFactAuth, auth: true });
    }

    function storePaymentId(paymentId) {
      GmyStorage.setSessionItem(COOKIE_NAME_PAYMENT_ID, paymentId);
    }
  }
})();
